import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { CheckoutFromSource } from '@libs/client/helpers/constant'

const SOURCE_VALUES = new Set<string>(Object.values(CheckoutFromSource))

export interface CheckoutSourceQuery {
  source?: string | string[]
  isBuyNow?: string | string[]
  isMultiCart?: string | string[]
  isFeedCartLayout?: string | string[]
}

export function resolveCheckoutFromSource(query: CheckoutSourceQuery): CheckoutFromSource {
  const { source, isBuyNow, isMultiCart, isFeedCartLayout } = query

  // New source param: value matches enum directly
  if (source && SOURCE_VALUES.has(source as string)) {
    return source as CheckoutFromSource
  }

  // Backward compat with old boolean flags
  if (isBuyNow === 'true') return CheckoutFromSource.BUY_NOW
  if (isMultiCart === 'true') return CheckoutFromSource.MULTI_CART
  if (isFeedCartLayout === 'true') return CheckoutFromSource.FEED_CART_LAYOUT_TAPPED

  return CheckoutFromSource.SINGLE_CART
}

export const useCheckoutFromSource = (): CheckoutFromSource => {
  const router = useRouter()
  const { source, isBuyNow, isMultiCart, isFeedCartLayout } = router.query

  return useMemo(
    () => resolveCheckoutFromSource({ source, isBuyNow, isMultiCart, isFeedCartLayout }),
    [source, isBuyNow, isMultiCart, isFeedCartLayout]
  )
}
